import {
    FilterBarGroup,
    getDefaultFilterGroupDef,
    IFilterGroupDef
} from "@components/smart/smartFilterBar/SmartFilterBar.types";
import { IReportHierarchy } from "@components/smart/smartTable";
import { CommonReportProps, getYearDef } from "@pages/reports/CommonDefs";
import {
    getEmployeeNumberOursCommonDef,
    getPayslipCommonDef,
    payslipInitialSortBy
} from "@pages/reports/payrollOverview/PayrollOverview.utils";
import { setReportDef } from "@pages/reports/Report.test.utils";
import i18next from "i18next";

import { IReportTableDefinition, TReportColumnOverrides } from "../Report.utils";
import { ReportId } from "../ReportIds";

export const getDefinition = (): IReportTableDefinition => {
    const tableId = ReportId.SocialSecurityContributionsOverview;
    const title = i18next.t("Reporting:SocialSecurityContributionsOverview.Title");
    const path = "SocialSecurityContributionsOverview";

    const filterBarDef: IFilterGroupDef[] = [{
        ...getDefaultFilterGroupDef(FilterBarGroup.Parameters),
        defaultFilters: [CommonReportProps.year],
        filterDefinition: {
            [CommonReportProps.year]: {
                ...getYearDef()
            }
        },
    }, {
        ...getDefaultFilterGroupDef(FilterBarGroup.Filters),
        allowCustomFilters: false,
        defaultFilters: [],
        filterDefinition: {}
    }];


    const parameters: string[] = [CommonReportProps.year];
    const defaultReportHierarchy: IReportHierarchy = {
        "Aggregate": false,
        "Groups": [],
        "Columns": [
            {
                "ColumnAlias": "YearMonth",
            },
            {
                "ColumnAlias": "PrEmployee_NumberOurs",
            },
            {
                "ColumnAlias": "Name",
            },
            {
                "ColumnAlias": "PrPayslipItem_CzSocialInsuranceEmployee",
            },
            {
                "ColumnAlias": "PrPayslipItem_CzSocialInsuranceEmployer",
            },
            {
                "ColumnAlias": "PrPayslipItem_SocialInsuranceTotal",
            },
            {
                "ColumnAlias": "PrPayslipItem_CzSocialInsuranceEmployeePercentage",
            },
            {
                "ColumnAlias": "PrPayslipItem_CzSocialInsuranceEmployerPercentage",
            },
            {
                "ColumnAlias": "PrSocialInsuranceDiscountType_Name",
            },
        ],
        "Aggregations": []
    };


    const columnOverrides: TReportColumnOverrides = {
        YearMonth: getPayslipCommonDef(),
        PrEmployee_NumberOurs: getEmployeeNumberOursCommonDef()
    };

    const initialSortBy = payslipInitialSortBy;

    return {
        title, path, id: tableId, initialSortBy, columnOverrides, filterBarDef, parameters, defaultReportHierarchy,
        disableAggregateButton: true
    };
};

setReportDef(ReportId.SocialSecurityContributionsOverview, getDefinition);